"use strict";

$(document).ready(function () {
  var page;
  var templateId = $('body').data('template');

  /*
   * Init Nette JS
   */
  $.nette.init();

  /*
  * Init page controller by template
  */
  switch (templateId) {
    case "bundle":
      page = new BundleController();
      break;
    case "sign":
      page = new SignController();
      break;
      break;
    default:
      // init generic page controller for other templates
      page = new PageController();
      break;
  }
  var form = new FormComponent();
  var mobileMenu = new MobileMenu();
});